import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'category-grid',
  name: '分类宫格',
  icon: '宫',
  group: '微短剧组件',
  description: '按剧本、场地、演员等服务分类做宫格导航',
  defaultProps: {
    title: '服务分类',
    limit: 8
}
}
